// extracted by mini-css-extract-plugin
module.exports = {"registerBtn":"styles_registerBtn__3ezT0","gotoLogin":"styles_gotoLogin__1aTTs","changeLocale":"styles_changeLocale__2YuP0"};